import { useEffect, useRef } from "react";
import type { ViewMode } from "../../shared/types";
import { track } from "./analytics";

export function usePageView(view: ViewMode): void {
  const prev = useRef<ViewMode | null>(null);

  useEffect(() => {
    if (view === prev.current) return;
    prev.current = view;
    track("page_viewed", { view });
  }, [view]);
}
